<template>
  <div id="app">
    <v-app id="inspire">
      <v-skeleton-loader
        v-if="!ActionSetEmployees"
        :loading="loading"
        type="table"
      ></v-skeleton-loader>
      <v-app id="inspire" class="l-content">
        <MainMenu />
        <NaviBar />
        <v-content>
          <Container />
          <Footer />
        </v-content>
      </v-app>
    </v-app>
  </div>
</template>
<script>
import Container from '@/components/layouts/dashboard/Container.vue'
import Footer from '@/components/layouts/dashboard/Footer.vue'
import MainMenu from '@/components/layouts/dashboard/MainMenu.vue'
import NaviBar from '@/components/layouts/dashboard/NaviBar.vue'

import { mapActions } from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    Container,
    Footer,
    MainMenu,
    NaviBar,
  },
  inject: ['theme'],
  methods: {
    ...mapActions('employees', ['ActionSetEmployees']),
  },
  created: function () {},
}
</script>
